import { axiosCall } from './utils/axios';
import { Datepicker } from 'vanillajs-datepicker';
import { getDateAsIsoString } from './helpers/time.js';
import fr from 'vanillajs-datepicker/locales/fr';

const handler = document.getElementById('slots-handler');
const loaderWrapper = document.querySelector(".b-loader-wrapper");

let currentSlot = null;
let isDateCanChange = false;
const accountName = handler.dataset.account;

const elem = document.getElementById('datepicker');
const mgasAccount = accountName === 'mgas';
const imhAccount = accountName === 'imh';
const assuroneAccount = accountName === 'assurone';
const matmutAccount = accountName === 'matmut';
const calizyAccount = accountName === 'calizy';

const url = new URL(window.location.href);
const pathname = url.pathname;
const isOnRescheduleSlotsPage = pathname.includes('reschedule_slots');
const isSlotTaken = url.searchParams.get('taken') === 'true';

const appointmentId = isOnRescheduleSlotsPage && imhAccount ? handler.dataset.appointmentid : null;

Object.assign(Datepicker.locales, fr);

let previousDate = null;

Datepicker.locales.fr = {
    ...Datepicker.locales.fr,
    daysMin: ['DIM', 'LUN', 'MAR', 'MER', 'JEU', 'VEN', 'SAM'],
};

const datepicker = new Datepicker(elem, {
    calendarWeeks: true,
    weekStart: 1,
    prevArrow: '&#8249;',
    nextArrow: '&#8250;',
    minDate: minDate(),
    maxDate: maxDate(),
    defaultViewDate: minDate(),
    language: handler.dataset.locale,
});

currentDateTextFormat(minDate());

const timeSlotsWrapper = document.querySelector('.js-slots-wrapper');
const submitButtonBlock = document.querySelector('.js-submit-button');
const submitButton = document.querySelector('.b-form-submit__button-next');
const slotAvailabilityModal = document.getElementById('slot-availability-modal');
const slotAvailabilityLoading = document.querySelector('.js-slot-availability-loading');
const slotAvailabilityError = document.querySelector('.js-slot-availability-error');
const slotAvailabilityBackButton = document.querySelector('.js-slot-availability-back');

const appointmentForm = submitButton?.closest('form');
const noResultBlock = document.querySelector('.b-no-result');
const prevMonth = document.querySelector('.prev-btn');
const nextMonth = document.querySelector('.next-btn');

// possible location methods
const locationMethods = {
    servicePointByPhone: 'service_point_by_phone',
    servicePoint:        'service_point',
    phone:               'phone',
    branch:              'ibpb',
    videoOnline:         'video_online',
    branchPhone:         'ibbppb',
    branchVideo:         'ibbvpb',
    onSite:              'os'
};

function minDate() {
    const todayDate = new Date();
    if (mgasAccount) {
        return new Date(new Date(todayDate.setDate(todayDate.getDate() + 2)).setHours(0, 0, 0, 0));
    }

    if (matmutAccount) {
        return new Date(new Date(todayDate.setHours(0, 0, 0, 0)));
    }

    return new Date(new Date(todayDate.setDate(todayDate.getDate() + 1)).setHours(0, 0, 0, 0));
}

function maxDate() {
    if (assuroneAccount) {
        const date = new Date();
        const dateTomorrow = date.setDate(date.getDate() + 1);
        return new Date(dateTomorrow).setDate(new Date(dateTomorrow).getDate() + 90);
    }

    if (calizyAccount || imhAccount) {
        const date = new Date();
        const dateTomorrow = date.setDate(date.getDate() + 1);
        return new Date(dateTomorrow).setDate(new Date(dateTomorrow).getDate() + 30);
    }

    return new Date(new Date().getFullYear(), new Date().getMonth() + 2, 0);
}

function getBaseParams(date) {
    return {
        account_id: handler.dataset.aid,
        ac_id: handler.dataset.acid,
        loc: handler.dataset.loc,
        ...(handler.dataset.advisorid && { advisor_id: handler.dataset.advisorid }),
        ...(handler.dataset.premid && handler.dataset.loc === locationMethods.branch && { branch_id: handler.dataset.premid }),
        ...(handler.dataset.premid && handler.dataset.loc === locationMethods.servicePoint && { sp_id: handler.dataset.premid }),
        ...(handler.dataset.premid && handler.dataset.loc === locationMethods.servicePointByPhone && { sp_id: handler.dataset.premid }),
        ...(handler.dataset.premid && handler.dataset.loc === locationMethods.branchPhone && { branch_id: handler.dataset.premid }),
        ...(handler.dataset.premid && handler.dataset.loc === locationMethods.branchVideo && { branch_id: handler.dataset.premid }),
        ...(handler.dataset.postcode && handler.dataset.loc === locationMethods.phone && { post_code: handler.dataset.postcode }),
        ...(handler.dataset.postcode && handler.dataset.loc === locationMethods.videoOnline && { post_code: handler.dataset.postcode }),
        ...(handler.dataset.postcode && handler.dataset.loc === locationMethods.onSite && { post_code: handler.dataset.postcode, origin: handler.dataset.origin }),
        ...(handler.dataset.iso && { country_iso: handler.dataset.iso }),
        ...date ? { from: date } : {},
        ...appointmentId ? { appointment_id: appointmentId } : {},
    };
}

function updateSelectedDate(date, isSelectMonth) {
    return (date && new Date(date).getMonth() !== new Date().getMonth()) || (!isSelectMonth && previousDate && new Date(previousDate).getMonth() !== new Date(date).getMonth()) ?
        new Date(date) :
        new Date(minDate());
}

async function getData(from, isSelectMonth = true) {
    const date = Object.assign({}, datepicker);
    const preparedFirstDateMonth = prepareDate(new Date(date.picker.currentView.first));
    const preparedDateToday = prepareDate(new Date(minDate()));
    const dateParam = preparedFirstDateMonth < preparedDateToday || imhAccount ? preparedDateToday : preparedFirstDateMonth;

    datepicker.setDate(updateSelectedDate(from, isSelectMonth));
    const data = await axiosCall({
        url: `/api/dates`,
        params: getBaseParams(dateParam),
    });
    if (data && data.dates) {
        updateDatePicker(data.dates, from);
    }

    return;
}

async function getTimeSlots(date) {
    return await axiosCall({
        url: `/api/timeslots`,
        params: {
            ...getBaseParams(), date,
        },
    });
}

function prepareDate(date) {
    return getDateAsIsoString(date);
}

function updateDatePicker(dates, dateFrom) {
    function getClass(date) {
        return dates.includes(prepareDate(date)) ? 'b-date-with-slots' : null;
    }

    datepicker.setOptions({
        defaultViewDate: updateSelectedDate(dateFrom),
        beforeShowDay: date => {
            return {
                enabled: true,
                classes: getClass(date),
            };
        }
    });
}

function getBaseSlots(responseSlots) {
    const slots = [];
    const startWorkingHour = 8;
    const finishWorkingHour = 19;
    const workingLength = finishWorkingHour - startWorkingHour;
    if (responseSlots && responseSlots.length) {
        for (let i = 0; i < workingLength; i++) {
            const hours = startWorkingHour + i;
            let hourStr = hours.toString();
            if (hourStr.length === 1) {
                hourStr = `0${hourStr}`;
            }
            ['00', '15', '30', '45'].forEach(minutes => {
                const slotsDate = +new Date(datepicker.picker.currentView.focused);
                const currentDate = +minDate();
                if (slotsDate >= currentDate) {
                    slots.push({
                        time: `${hourStr}:${minutes}`,
                        hours,
                        minutes: parseInt(minutes),
                    })
                }
            })
        }
    }

    return slots;
}

function prepareTimeSlots(timeslots) {
    const slots = getBaseSlots(timeslots);
    if (slots && slots.length) {
        for (let i = 0; i < slots.length; i++) {
            const div = document.createElement('div');
            const content = document.createTextNode(slots[i].time);
            div.className = 'b-main-container__slots__item';
            const divInner = document.createElement('div');
            divInner.className = 'b-main-container__slots__item__inner h-secondary-text';
            divInner.classList.add('js-current-slot');
            divInner.tabIndex = 0;
            divInner.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    divInner.click();
                }
            });
            const isTimeSlotExists = !!timeslots.find(timeslot => {
                const date = new Date(timeslot.slot);
                if (date.getUTCHours() === slots[i].hours && date.getUTCMinutes() === slots[i].minutes) {
                    divInner.setAttribute('data-uid', timeslot.id);
                    divInner.setAttribute('data-slot', timeslot.slot);
                    if (timeslot.duration_to_in_seconds && timeslot.duration_from_in_seconds) {
                        divInner.setAttribute('data-to', timeslot.duration_to_in_seconds);
                        divInner.setAttribute('data-from', timeslot.duration_from_in_seconds);
                    }
                }
                return date.getUTCHours() === slots[i].hours && date.getUTCMinutes() === slots[i].minutes;
            });
            if (isTimeSlotExists) {
                divInner.classList.add('b-main-container__slots__item__inner--exists')
            } else {
                divInner.classList.add('b-main-container__slots__item__inner--disabled')
            }
            // datepicker.config.defaultViewDate
            divInner.appendChild(content);
            div.append(divInner);
            timeSlotsWrapper.append(div);

        }
        document.querySelectorAll('.js-current-slot').forEach(item => {
            const chosenTimeslot = document.getElementById('appointment-timeslot');
            const chosenTimeslotId = document.getElementById('appointment-uid');
            const chosenTimeslotDurationTo = document.getElementById('appointment-duration-to');
            const chosenTimeslotDurationFrom = document.getElementById('appointment-duration-from');
            item.addEventListener('click', event => {
                const currentActive = document.querySelector('.b-main-container__slots__item__inner--active');
                if (currentActive) {
                    currentActive.classList.remove('b-main-container__slots__item__inner--active');
                }
                currentSlot = event.target;
                const timeAttribute = currentSlot.getAttribute('data-slot');
                const idAttribute = currentSlot.getAttribute('data-uid');
                const fromAttribute = currentSlot.getAttribute('data-from');
                const toAttribute = currentSlot.getAttribute('data-to');
                if (timeAttribute && idAttribute) {
                    submitButton.disabled = false;
                }
                chosenTimeslot.value = timeAttribute;
                chosenTimeslotId.value = idAttribute;
                if (chosenTimeslotDurationTo && chosenTimeslotDurationFrom) {
                    chosenTimeslotDurationTo.value = toAttribute;
                    chosenTimeslotDurationFrom.value = fromAttribute;
                }
                item.classList.add('b-main-container__slots__item__inner--active');
            });
        });
    } else  {
        submitButtonBlock.style.display = 'none';
        noResultBlock.style.display = 'flex';
        timeSlotsWrapper.innerHTML = '';
    }
}

async function updateSlotsByDate(date) {
    loaderWrapper.style.display = 'flex';
    submitButtonBlock.style.display = 'none';
    noResultBlock.style.display = 'none';
    submitButton.disabled = true;
    timeSlotsWrapper.innerHTML = '';
    const slots = await getTimeSlots(prepareDate(date));
    loaderWrapper.style.display = 'none';
    if (slots && slots.timeslots) {
        submitButtonBlock.style.display = 'flex';
        prepareTimeSlots(slots.timeslots);
    } else {
        noResultBlock.style.display = 'flex';
    }
}

function currentDateTextFormat(date){
    const dateHeader = document.querySelector('.b-main-container__right--title');
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const focusedDate  = new Date(date);
    dateHeader.innerHTML = focusedDate.toLocaleDateString(handler.dataset.locale, options);
}

function showSlotAvailabilityLoader() {
    if (!slotAvailabilityModal) return;

    slotAvailabilityLoading.style.display = 'flex';
    slotAvailabilityError.style.display = 'none';
    slotAvailabilityModal.style.display = 'flex';
}

function showSlotAvailabilityError() {
    if (!slotAvailabilityModal) return;

    slotAvailabilityLoading.style.display = 'none';
    slotAvailabilityError.style.display = 'flex';
    slotAvailabilityModal.style.display = 'flex';
}

function hideSlotAvailabilityModal() {
    if (!slotAvailabilityModal) return;

    slotAvailabilityModal.style.display = 'none';
}

if (isSlotTaken) {
    showSlotAvailabilityError();
}

if (appointmentForm) {
    appointmentForm.addEventListener('submit', () => {
        showSlotAvailabilityLoader();
    });
}

if (slotAvailabilityBackButton) {
    slotAvailabilityBackButton.addEventListener('click', () => {
        hideSlotAvailabilityModal();

        url.searchParams.delete('taken');
        window.history.replaceState({}, '', url);
    });
}

datepicker.element.addEventListener('changeDate', event => {
    if (isDateCanChange) {
        const { detail } = event;
        if (!previousDate && new Date(datepicker.config.defaultViewDate).getMonth() !== new Date(event.detail.date).getMonth() ||
            (previousDate && new Date(previousDate).getMonth() !== new Date(event.detail.date).getMonth())) {
            getData(prepareDate(detail.date), false);
        }
        previousDate = detail.date;
        currentDateTextFormat(detail.date);
        updateSlotsByDate(detail.date);

    }
});

document.addEventListener('DOMContentLoaded', async function() {
    try {
        await Promise.all([
            getData(prepareDate(minDate()), true),
            updateSlotsByDate(minDate())
        ])
        isDateCanChange = true;

    } catch (e) {
        console.log(e);
    } finally {
        loaderWrapper.style.display = 'none';
    }
});

prevMonth.addEventListener('click', event => {
    const date = Object.assign({}, datepicker);
    const firstDateMonth = new Date(date.picker.currentView.first);

    getData(prepareDate(firstDateMonth), true);
});

nextMonth.addEventListener('click', event => {
    const date = Object.assign({}, datepicker);
    const firstDateMonth = new Date(date.picker.currentView.first);

    getData(prepareDate(firstDateMonth), true);
});

if(elem) {
    elem.addEventListener('keydown', (event) => {
        const focused = document.activeElement;

        if (!focused.classList.contains('datepicker-cell')) return;

        let target;
        switch (event.key) {
            case 'ArrowLeft':
                target = focused.previousElementSibling;
                break;
            case 'ArrowRight':
                target = focused.nextElementSibling;
                break;
            case 'ArrowUp':
            case 'ArrowDown': {
                const direction = event.key === 'ArrowUp' ? -7 : 7;
                const cells = [...elem.querySelectorAll('.datepicker-cell')];
                const index = cells.indexOf(focused);
                target = cells[index + direction];
                break;
            }
            case 'Enter':
            case ' ':
                focused.click();
                break;
        }

        if (target && target.classList.contains('datepicker-cell')) {
            focused.setAttribute('tabindex', '-1');
            target.setAttribute('tabindex', '0');
            target.focus();
            event.preventDefault();
        }
    });
}
